import * as api from "@/api";
import { hospitalCatchmentEmails } from "@lab/api/emails.api";
import { Digest } from "@/shared/types/hospitals";
export default {
	state: {
		digest: {
			id: null,
			addresses: "",
			dayslist: [],
			emails: [],
			type: "hospitalcatchment",
			typeid: 0
		}
	},
	getters: {
		digest: (state: any): Digest => state.digest,
		dayslist: (state: any): string[] => state.digest.dayslist,
		emailslist: (state: any): string[] => state.digest.emails,
		addresses: (state: any): string => state.digest.addresses
	},
	actions: {
		async loadDigest(context: any, hospitalid: number) {
			try {
				const digest = await hospitalCatchmentEmails(hospitalid);
				context.commit(`autoEmailsSuccess`, digest);
			} catch (error) {
				// context.commit(`autoEmailsLoadFailure`, error.message);
				// throw error;
			}
		},
		updateDayslist(context: any, list: string[]) {
			context.commit("updateDayslist", list);
		},
		updateEmailslist(context: any, emails: string[]) {
			context.commit("updateEmailslist", emails);
		},
		resetVacancyDigest(context: any) {
			context.commit("updateEmailslist", []);
			context.commit("updateDayslist", []);
		}
	},
	mutations: {
		autoEmailsSuccess(state: any, digest: Digest) {
			state.digest = digest;
		},
		updateDayslist(state: any, list: string[]) {
			state.digest.dayslist = list;
		},
		updateEmailslist(state: any, emails: string[]) {
			state.digest.addresses = emails.join(",");
			state.digest.emails = emails;
		}
	}
};
